import type { SelectValue } from 'antd/lib/select/index';
import React from 'react';
import styled from 'styled-components/macro';
import { useSelector, useDispatch } from 'react-redux';
import { Select as AntdSelect } from 'antd';
import { FormattedMessage } from 'react-intl';
import {
  setIsOperating,
  getIsOperatingAsNumber,
} from 'routes/tourOperator/flightCache/flightRoutes/comp/flightRoutesFilters';
import LabeledValue from 'comp/dataPresentation/labeledValue/LabeledValue';
import mediaQuery from 'styles/utils/mediaQuery';

const options = [
  { value: 0, label: 'No' },
  { value: 1, label: 'Yes' },
];

function IsOperating(): JSX.Element {
  const value = useSelector(getIsOperatingAsNumber);
  const dispatch = useDispatch();

  function handleOnChange(option: SelectValue) {
    if (option === undefined) {
      dispatch(setIsOperating(null));
    } else {
      dispatch(setIsOperating(!!option));
    }
  }

  return (
    <LabeledValue label={{ id: 'isOperating' }}>
      <Select
        allowClear
        placeholder={<FormattedMessage id='isOperating.placeholder' />}
        options={options}
        value={value}
        onChange={handleOnChange}
      />
    </LabeledValue>
  );
}

export default IsOperating;

const Select = styled(AntdSelect)`
  width: 100%;

  ${mediaQuery.fromAndAbove.medium`
    width: 200px;
  `}
`;
